<template>
    <BaseSelect
        v-if="isEditMode"
        v-model="val"
        :options="timezones"
        :custom-label="label"
        :placeholder="$t('Time zone')"
        searchable
    />
    <span v-else>
        <span v-if="val">{{ val.timezone }}, {{ val.offset }}</span>
        <span v-else>-</span>
    </span>
</template>

<script>
import BaseSelect from '@components/BaseSelect';

export default {
    name: 'TimezoneSelect',

    compatConfig: {
        MODE: 3,
    },

    components: {
        BaseSelect,
    },

    props: {
        modelValue: {
            type: String,
            default: null,
            nullable: true,
        },
        isEditMode: Boolean,
    },

    emits: ['update:modelValue'],

    computed: {
        timezones() {
            return this.$store.getters['classifiers/timezones'];
        },
        val: {
            get() {
                const val = this.modelValue || Intl.DateTimeFormat().resolvedOptions().timeZone;
                return this.timezones.find((i) => i.timezone === val);
            },
            set(value) {
                this.$emit('update:modelValue', value?.timezone);
            },
        },
    },

    created() {
        this.$store.dispatch('classifiers/getTImezones');
    },

    methods: {
        label(item) {
            return `(${item.offset}) ${item.timezone}`;
        },
    },
};
</script>
